import "select2/dist/js/select2.full.js";
import "jquery-datepicker/jquery-datepicker.js";

import datepickerFactory from 'jquery-datepicker';

datepickerFactory($);

$(document).ready(() => {
    $('.select-element').select2({
        dropdownCssClass: 'select2-form-dropdown',
        minimumResultsForSearch: -1
    });

    $('.datepicker').datepicker({
        showOtherMonths: true,
        selectOtherMonths: true,
        dateFormat: 'yy-mm-dd'
    });
});
